<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZMSy5a/media/FC-9781035870615.jpg?1721600811993" alt="This image is the cover for the book The Fields of Britannia : The Darkness Before the Dawn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Fields of Britannia : The Darkness Before the Dawn
      </h1>
      <p class="bookDescription body article font2">
        <p>It’s the year 367 AD, and the Roman military presence in quiet Brittania has dwindled to a mere few thousand legionaries made up of green recruits and tired veterans, with the mightiest of the legions having been pulled out of the province to fight in the gigantic power struggles for the Imperial throne, as Emperors rise and fall with astonishing speed. Not unnoticed by the barbarian tribes beyond Hadrian’s wall and across the Irish sea, or by the fast-growing Saxon presence beyond the Rhine, the enemies of Rome begin to make plans to bring fire and blood to Britannia, and remove the Roman presence from the island for good… In a story that will take you across England from the coast of Dover to the very edge of the Roman Empire, our heroes will be beset by enemies on all sides and have to fight against despair, overwhelming odds and their own prejudices in order to pull together and survive the onslaught.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel Duckworth
      </h2>
      
      <p class="authorDescription body article">Born in the Northwest of England, and currently living in Bolton with his partner, Daniel has always had a passion for history and for those individual stories of people who lived through great moments in time. After studying history at University, his career moved away from academia, but he has now returned to his passion of sharing the stories of ordinary people as they struggled and fought to find their place within the great story of human history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b01c870